import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e75b7262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["onClick"]

import { ref, computed } from 'vue';

/**
 * TYPES
 */
type Props = {
  options: Array<any>;
  minWidth?: string;
};

/**
 * PROPS & EMITS
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BalDropdown',
  props: {
    options: null,
    minWidth: { default: 'auto' }
  },
  emits: ["selected"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'selected', value: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { options: Array<any>, minWidth: string };





/**
 * STATE
 */
const showDropdown = ref(false);

/**
 * COMPUTED
 */
const dropdownClasses = computed(() => ({
  [`min-w-${props.minWidth}`]: true,
}));

/**
 * METHODS
 */
function toggleDropdown(): void {
  showDropdown.value = !showDropdown.value;
}

function hideDropdown(): void {
  showDropdown.value = false;
}

function handleRowClick(option: any): void {
  emit('selected', option);
  hideDropdown();
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "activator",
      onClick: toggleDropdown
    }, [
      _renderSlot(_ctx.$slots, "activator")
    ]),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['bal-dropdown', _unref(dropdownClasses)])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "bal-dropdown-row",
              onClick: ($event: any) => (handleRowClick(option))
            }, [
              _renderSlot(_ctx.$slots, "option", { option: option })
            ], 8, _hoisted_2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, hideDropdown]
  ])
}
}

})